import axios from 'axios';
import { Action, createAction, handleActions } from 'redux-actions';
import { FULFILLED, PENDING, REJECTED } from './action-type.util';
import { IOrder as IModel } from './order.model';
import { mapOrderItem, mapOrders } from './order.utils';
import {
    getAxiosData,
    getRejectedRespData,
    initPagingList,
    IPaging,
    parsePagingToParams,
    parseToPaging,
    SERVER_API_URL,
} from '../config/constants';
import { parseEmptyField } from '../shared/utils/utils';
import order from './api/order.json';
import orders from './api/orders.json';

const MOCK_SERVER = false;

export const ACTION_TYPES = {
    UPDATE_STATE: 'order/UPDATE_STATE',
    SET_PAGING: 'order/SET_PAGING',
    RESET_PAGING: 'order/RESET_PAGING',
    GET: 'order/GET',
    GET_LIST: 'order/GET_LIST',
    GET_BY_ID: 'order/GET_BY_ID',
    DELETE: 'order/DELETE',
    SAVE: 'order/SAVE',
};

export interface IOrderState {
    loading: boolean;
    error: any;
    list: IModel[];
    listShort: IModel[];
    data: IModel;
    paging: IPaging;
}

const initState = {
    loading: false,
    error: null,
    list: [],
    listShort: [],
    data: {} as IModel,
    paging: { ...initPagingList },
};

export const updateState = createAction(ACTION_TYPES.UPDATE_STATE);
export const setPaging = createAction(ACTION_TYPES.SET_PAGING);
export const resetPaging = createAction(ACTION_TYPES.RESET_PAGING);

export const get = createAction<any, any>(ACTION_TYPES.GET, (params?: any) =>
    MOCK_SERVER
        ? Promise.resolve(orders)
        : getAxiosData(
              axios.get(`${SERVER_API_URL}/orders`, {
                  params: parsePagingToParams({ ...initPagingList, ...params }),
              }),
          ),
);
export const getList = createAction(ACTION_TYPES.GET_LIST, (params: any) =>
    getAxiosData(axios.get(`${SERVER_API_URL}/orders/list`, { params })),
);
export const getById = createAction(ACTION_TYPES.GET_BY_ID, (id: string) =>
    MOCK_SERVER ? Promise.resolve(order) : getAxiosData(axios.get(`${SERVER_API_URL}/orders/${id}`)),
);
export const remove = createAction(ACTION_TYPES.DELETE, async (id: string) => {
    await getAxiosData(axios.delete(`${SERVER_API_URL}/orders/${id}`));
    return id;
});
export const save = createAction(ACTION_TYPES.SAVE, (body: any) =>
    body.id
        ? getAxiosData(axios.put(`${SERVER_API_URL}/orders/${body.id}`, parseEmptyField(body)))
        : getAxiosData(axios.post(`${SERVER_API_URL}/orders`, parseEmptyField(body))),
);

/* Reducer function */
const onPending = (state: IOrderState): IOrderState => ({ ...state, loading: true });
// const onPendingCancel = (state: IOrderState): IOrderState => ({ ...state, loading: false });
const onRejected = (state: IOrderState, action: Action<any>): IOrderState => ({
    ...state,
    error: getRejectedRespData(action.payload),
    loading: false,
});
const onGetListShort = (state: IOrderState, action: Action<any[]>): IOrderState => ({
    ...state,
    loading: false,
    listShort: mapOrders(action.payload),
});
const onSetItem = (state: IOrderState, action: Action<any>): IOrderState => ({
    ...state,
    loading: false,
    data: mapOrderItem(action.payload),
});
/* Reducer function end */

export default handleActions<IOrderState, any>(
    {
        [ACTION_TYPES.UPDATE_STATE]: (state: IOrderState, action: Action<any>): IOrderState => ({
            ...state,
            ...action.payload,
        }),
        [ACTION_TYPES.SET_PAGING]: (state: IOrderState, action: Action<IPaging>): IOrderState => ({
            ...state,
            paging: { ...state.paging, ...parseToPaging(action.payload) },
        }),
        [ACTION_TYPES.RESET_PAGING]: (state: IOrderState): IOrderState => ({
            ...state,
            paging: { ...initPagingList },
        }),

        [PENDING(ACTION_TYPES.GET)]: onPending,
        [REJECTED(ACTION_TYPES.GET)]: onRejected,
        [FULFILLED(ACTION_TYPES.GET)]: (state: IOrderState, action: Action<any>): IOrderState => {
            const { page: list = [], ...paging } = action.payload;
            return { ...state, loading: false, list: mapOrders(list), paging: { ...state.paging, ...paging } };
        },

        [PENDING(ACTION_TYPES.GET_BY_ID)]: onPending,
        [REJECTED(ACTION_TYPES.GET_BY_ID)]: onRejected,
        [FULFILLED(ACTION_TYPES.GET_BY_ID)]: onSetItem,

        [PENDING(ACTION_TYPES.GET_LIST)]: onPending,
        [REJECTED(ACTION_TYPES.GET_LIST)]: onRejected,
        [FULFILLED(ACTION_TYPES.GET_LIST)]: onGetListShort,

        [PENDING(ACTION_TYPES.DELETE)]: onPending,
        [REJECTED(ACTION_TYPES.DELETE)]: onRejected,
        [FULFILLED(ACTION_TYPES.DELETE)]: (state: IOrderState, action: Action<any>): IOrderState => ({
            ...state,
            loading: false,
            list: state.list.filter((el: IModel) => el.id !== action.payload),
            listShort: state.listShort.filter((el: IModel) => el.id !== action.payload),
        }),

        [PENDING(ACTION_TYPES.SAVE)]: onPending,
        [REJECTED(ACTION_TYPES.SAVE)]: onRejected,
        [FULFILLED(ACTION_TYPES.SAVE)]: onSetItem,

        /* WS events */
        /* WS events end */
    },
    initState,
);
